import { render, staticRenderFns } from "./typeAuth.vue?vue&type=template&id=6c0ac848&scoped=true&"
import script from "./typeAuth.vue?vue&type=script&lang=js&"
export * from "./typeAuth.vue?vue&type=script&lang=js&"
import style0 from "./typeAuth.vue?vue&type=style&index=0&id=6c0ac848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0ac848",
  null
  
)

export default component.exports